import React from 'react';
import { Routes, Route, BrowserRouter } from 'react-router-dom';
import { AuthAdminRouter } from './AuthAdminRouter';

export const AppRouter = () => {
    return (
        <div>
            <BrowserRouter>
                <Routes>
                    <Route path="/admin/*" exact element={<AuthAdminRouter />} />
                    <Route path="*" exact element={<AuthAdminRouter />} />
                </Routes>
            </BrowserRouter>
        </div>
    );
};
